const storage = localStorage.getItem('remember') ? localStorage : sessionStorage

const state = {
  isACast: false,
  remember: localStorage.getItem('remember') || false,
  userInfo: JSON.parse(storage.getItem('userInfo')) || {},
  token: storage.getItem('token') || '',
  tokenExpired: storage.getItem('tokenExpired') || '',
  twilioClientAccessToken: storage.getItem('twilio_client_access_token') || '',
  taskRouterToken: storage.getItem('task_router_token') || '',
  userCompany: storage.getItem('userCompany') || {}
}

const getters = {
  getRemember (state) {
    return state.remember
  },
  getToken (state) {
    return state.token
  },
  getTokenExpired (state) {
    return state.tokenExpired
  },
  getTwilioClientAccessToken (state) {
    return state.twilioClientAccessToken
  },
  getTaskRouterToken (state) {
    return state.taskRouterToken
  },
  getUserInfo (state) {
    return state.userInfo
  },
  getIsACast (state) {
    return state.isACast
  },
  getUserCompany (state) {
    return state.userCompany
  }
}

const mutations = {
  SET_TOKEN (state, payload) {
    state.remember = payload.remember
    state.token = payload.token
    state.tokenExpired = payload.tokenExpired
    state.twilioClientAccessToken = payload.twilioClientAccessToken
    state.taskRouterToken = payload.taskRouterToken
    let storage = sessionStorage
    if (payload.remember) {
      localStorage.setItem('remember', payload.remember ?? '')
      storage = localStorage
    }
    storage.setItem('token', payload.token)
    storage.setItem('tokenExpired', payload.tokenExpired)
    storage.setItem('twilio_client_access_token', payload.twilioClientAccessToken)
    storage.setItem('task_router_token', payload.taskRouterToken)
    storage.setItem('phoneCti', payload.phoneCti)
    storage.setItem('tokenRefresh', payload.tokenRefresh)
    storage.setItem('tokenExpiredRefresh', payload.tokenExpiredRefresh)
  },
  SET_USER_INFO (state, payload) {
    state.userInfo = payload
    if (payload.remember) {
      localStorage.setItem('userInfo', JSON.stringify(payload))
      localStorage.setItem('email', payload.email)
      return
    }
    localStorage.removeItem('email')
    sessionStorage.setItem('userInfo', JSON.stringify(payload))
  },
  SET_USER_COMPANY (state, payload) {
    state.userCompany = payload
    localStorage.setItem('userCompany', JSON.stringify(payload))
  },
  SET_CHANGED_PASSWORD (state) {
    let storage = sessionStorage
    if (localStorage.getItem('remember')) {
      storage = localStorage
    }
    const userInfo = JSON.parse(storage.getItem('userInfo'))
    userInfo.password_changed = true
    state.userInfo = userInfo
    storage.setItem('userInfo', JSON.stringify(userInfo))
  },
  LOG_OUT (state) {
    const storage = localStorage.getItem('remember') ? localStorage : sessionStorage
    storage.removeItem('userInfo')
    storage.removeItem('userCompany')
    storage.removeItem('token')
    storage.removeItem('tokenExpired')
    storage.removeItem('twilio_client_access_token')
    storage.removeItem('task_router_token')
    storage.removeItem('phoneCti')
    storage.removeItem('tokenRefresh')
    storage.removeItem('tokenExpiredRefresh')
    localStorage.removeItem('remember')
    state.userInfo = {}
    state.userCompany = {}
    state.token = ''
    state.twilioClientAccessToken = ''
    state.taskRouterToken = ''
  },
  REFRESH_TWILIO_TOKEN (state, payload) {
    state.twilioClientAccessToken = payload.twilioClientAccessToken
    state.taskRouterToken = payload.taskRouterToken
    let storage = sessionStorage
    if (payload.remember) {
      storage = localStorage
    }
    storage.setItem('twilio_client_access_token', payload.twilioClientAccessToken)
    storage.setItem('task_router_token', payload.taskRouterToken)
  },
  SET_IS_A_CAST (state, payload) {
    state.isACast = payload
  }
}

const actions = {
  setToken (context, payload) {
    context.commit('SET_TOKEN', payload)
  },
  setUserInfo (context, payload) {
    context.commit('SET_USER_INFO', payload)
  },
  setUserCompany (context, payload) {
    context.commit('SET_USER_COMPANY', payload)
  },
  setChangedPassword (context) {
    context.commit('SET_CHANGED_PASSWORD')
  },
  logout ({ commit }) {
    commit('LOG_OUT')
  },
  refreshTwilioToken (context, payload) {
    context.commit('REFRESH_TWILIO_TOKEN', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
